import React, { useState } from 'react'
import StaffAnalytics from './StaffAnalytics'
import ShiftManagement from './ShiftManagement'
import StaffManagementInfo from './StaffManagementInfo'

const TABS = [
    {
        key: 'baristas',
        label: 'Manage Baristas',
        icon: (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2m0 5h-2V5h2zM4 19h16v2H4z"/>
            </svg>
        ),
    },
    {
        key: 'analytics',
        label: 'Staff Analytics',
        icon: (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
        ),
    },
    {
        key: 'shifts',
        label: 'Shift Management',
        icon: (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
        ),
    },
]

export default function StaffManagementStaff({ adminStaffData }) {
    const [activeTab, setActiveTab] = useState('analytics')

    return (
        <div>
            <div className="flex bg-gray-100 rounded-full p-1 gap-1 mx-4 sm:mx-6 mt-4 mb-2 overflow-x-auto max-w-full">
                {TABS.map(({ key, label, icon }) => (
                    <button
                        key={key}
                        onClick={() => setActiveTab(key)}
                        className={`flex items-center gap-1.5 px-3 sm:px-4 py-1.5 rounded-full
                            text-sm font-medium transition-all shrink-0 whitespace-nowrap ${
                            activeTab === key
                                ? 'bg-[#A0826D] text-white shadow-sm border border-gray-200'
                                : 'text-gray-500 hover:text-gray-700'
                        }`}>
                        {icon}
                        {label}
                    </button>
                ))}
            </div>

            {activeTab === 'baristas' && <StaffManagementInfo adminStaffData={adminStaffData} />}
            {activeTab === 'analytics' && <StaffAnalytics adminStaffData={adminStaffData} />}
            {activeTab === 'shifts' && <ShiftManagement branchId={adminStaffData.branch_id} />}
        </div>
    )
}